import React, { useEffect, useState } from "react"
import LoadingPage from "../reusableComponents/loader/loadingPage";
import { toast } from "react-toastify";
import Select from 'react-select';
import {   REACT_APP_VAM_ENDPOINT, REACT_APP_VAM_CONTEXT_FIELD, REACT_APP_VAM_CONTEXT_SURVEYOR, REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_CONTEXT_VENDOR} from "../urls";
import { editModeOn, getFromDecreaptLocalStorage } from "../utilFunctions";
import { axiosRequest } from "../service";
import "../scss/fieldSurvey.scss"
import { fieldSurveyStatus, functionalities } from "../consts";

const FieldSurveyRequest = (props) => {
  const { moduleText, confirmationText, id, api,claimDetailCookie, notifyPayload, setNotifyPayload,notified, setNotified, getClaimDetails, getFieldSurveyLists, reAssignVendor,isBulkSurveyRequest,submitBulkSurvey,isBulkReSurveyRequest ,submitBulkReSurvey,bulkReSurveyLoading,setBulkReSurveyLoading, disableRequest, requestButtonText,surveyorName,surveyStatus,roleDataCookie, hideVendorName= false , vendorId} = props
  const [showRequestFieldSurvey, setShowRequestFieldSurvey] = useState(false)
  const [confirmedRequestFieldSurvey, setConfirmedRequestFieldSurvey] = useState(false)
  const [surveyReqLoading, setSurveyReqLoading] = useState(false)
  const [reason, setReason] = useState("")
  const [vendorList, setVendorsList] = useState([])
  const [surveyorList, setSurveyorList] = useState([])
  const [qcLeadList, setQCleadList] = useState([]);
  const [qcExecutiveList, setQCExecutiveList] = useState([]);
  const [confirmFirstScreen, setConfirmFirstScreen] = useState(false)
  const [loadingRequest, setLoadingRequest] = useState(false)
  const policyDetailCookie = getFromDecreaptLocalStorage("policyDetail")
  const [surveyor, setSurveyor] = useState({
    value: 'select',
    label: 'select'
  })

  useEffect(()=>{
    setSurveyReqLoading(false)
    setShowRequestFieldSurvey(false)
    // setNotified(true)
    },[bulkReSurveyLoading == true])
  useEffect(()=>{
    getVendorsList();
    getQCList();
  },[])
  const getVendorsList = () => {
    axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_VENDOR}/searchVendorMaster`,{state:null, vendorType:null})
        .then(data => {
          setVendorsList(data.data.map(data => ({
          label: data.vendorName,
          value: data.vendorId
      })))
        }).catch(error => {
            console.log(error)
     })
  }
  const getQCList = () =>{
    // axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/roles/QC_LEAD`)
    //     .then(data => {
    //       const formattedData = data.data.map((lead) => ({
    //         value: lead,
    //         label: lead,
    //       }));
  
    //       setQCleadList(formattedData);
  
    //       //setQCleadList()
    //     }).catch(error => {
    //         console.log(error)
    //  })
     axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/roles/QC_EXECUTIVE`)
        .then(data => {
          const formattedData = data.data.map((lead) => ({
            value: lead,
            label: lead,
          }));
  
          setQCExecutiveList(formattedData);
  
          //setQCleadList()
        }).catch(error => {
            console.log(error)
     })
  }
  const getSurveyorList = (vendorId) => {
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}/getSurveyorAndQCMasterList/${vendorId}`)
       .then(data => {
        let formattedData = data.data
        .map(lead => ({
            value: lead.mobileNumber,
            label: `${lead.firstName} ${lead.lastName ?lead.lastName : ''} ${lead.mobileNumber ? `(${lead.mobileNumber})` : ''}`,
            name: `${lead.firstName}${lead.lastName ? ' '+ lead.lastName : ''}`,
            email: lead.email,
          }));

          if (surveyorName) {
            formattedData = formattedData.filter((data) => data.name !== surveyorName);
          }
          setSurveyorList(formattedData);
        }).catch(error => {
            console.error(error);
     });
};

  const submitRequestSurvey = async() => {
   
    if(notifyPayload.surveyorName==""){
      toast.error("Please Select Surveyor");
      return;
    }
    if(notifyPayload.vendorName==""){
      toast.error("Please Select Vendor");
      return;
    }
    if(isBulkReSurveyRequest && notifyPayload.comments==""){
      toast.error("Please Enter Remarks");
      return;
    }

    // if(notifyPayload.qcLead==""){
    //   toast.error("Please Select QC Lead")
    //   return;
    // }
    // if(notifyPayload.qcExecutive==""){
    //   toast.error("Please Select QC Executive")
    //   return;
    // }
    
    setLoadingRequest(true)
    setShowRequestFieldSurvey(true)
    setSurveyReqLoading(true)
    if(isBulkSurveyRequest){
      submitBulkSurvey()
      setLoadingRequest(false)
      setNotifyPayload({...notifyPayload,surveyorName:"",vendorName:"",qcLead:"",qcExecutive:""})
      return
    }
    if(isBulkReSurveyRequest){
      submitBulkReSurvey(notifyPayload)
      setLoadingRequest(false)
      setNotifyPayload({...notifyPayload,surveyorName:"",vendorName:"",qcLead:"",qcExecutive:""})
      return
    }
    axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_FIELD}/notifyFieldSurvey`, { ...notifyPayload}).then(data => {
      getFieldSurveyLists()
      setSurveyReqLoading(false)
      setShowRequestFieldSurvey(false)
      setNotified(true)
      if(data.data.responseInformation.responseMessage) toast.success('Surveyor Assigned Successfully')
      getClaimDetails(id, false)
      setNotifyPayload({...notifyPayload,surveyorName:"",vendorName:"",qcLead:"",qcExecutive:""})
    }).catch(error => {
      console.log(error)
      setNotified(false)
      setNotifyPayload({...notifyPayload,surveyorName:"",vendorName:"",qcLead:"",qcExecutive:""})
      setSurveyReqLoading(false)
    }).finally(() => {
      setLoadingRequest(false)
      setNotified(false)
      setNotifyPayload({...notifyPayload,surveyorName:"",vendorName:"",qcLead:"",qcExecutive:""})
      setSurveyReqLoading(false)
    })
  }
  const reAssignSurvey = () => {
    if(notifyPayload.surveyorName==""){
      toast.error("Please Select Surveyor");
      return;
    }
    if(notifyPayload.vendorName==""){
      toast.error("Please Select Vendor");
      return;
    }
    setLoadingRequest(true)
    axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_FIELD}/reAssignSurveyor`, { ...notifyPayload, claimIntimationNumber: claimDetailCookie?.claimNo })
      .then(data => {
        if (data.data === "Surveyor Re-assignement has been Failed")
          toast.error(data.data);
        else {
          toast.success(data.data)
        }
        getFieldSurveyLists()
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        setLoadingRequest(false)
      })
  }
  const clearData = () => {
    setShowRequestFieldSurvey(false)
    setNotifyPayload({...notifyPayload,surveyorName:"",vendorName:"",comments:"",qcLead:"",qcExecutive:""})
    setReason("")
    setSurveyor({
      value: 'select',
      label: 'select'
    })
  }

  useEffect(()=> {
    if(vendorId) {
      getSurveyorList(vendorId)
    }
  }, [vendorId])
  return (
    <>
    {editModeOn(functionalities.FS_REQUEST) && (
      reAssignVendor ? (
        <span className="ms-2 d-inline pointer text-primary fw-bold" onClick={() => setShowRequestFieldSurvey(true)}>+Re Assign</span>
      ) : (
        <div 
        onClick={() => {
          if ((claimDetailCookie.assignedTo === "Unassigned" || !claimDetailCookie.assignedTo) && !isBulkSurveyRequest && !isBulkReSurveyRequest){
            toast.error("Please Assign Claims Handler.")
            return
          }
          setShowRequestFieldSurvey(true);
          setBulkReSurveyLoading && setBulkReSurveyLoading(false)
        }}
        className={`requestCalc fw-bold ${disableRequest ? 'disabled-div ': ''}`}
        >
          {requestButtonText ? requestButtonText: 'Request Field Survey'}
        </div>
      ))
    }
      
      {
        showRequestFieldSurvey && (
          <div id="overlay12Field" className="text-start" style={{fontSize: "16px"}}>
            {
              loadingRequest ? (
                <LoadingPage/>
              ) : (
                <>
                <div className = "overlay_textCalc text-right me-3"><span type="button" onClick={() => setShowRequestFieldSurvey(false)} className="close" aria-label="Close">
                <span aria-hidden="true">&times;</span></span></div>
                <div style={{ paddingLeft: "20px" }}>
                  
                { isBulkReSurveyRequest &&( <div>
                  <div className="col-xl-11 col-lg-11 col-md-11 col-sm-11">
                  <div className="align_overlay2Field mt-2">
                      Remarks <span className="asteriskField"></span>
                    </div>
                  <div className="align_data_overlay2Field">
                  <textarea
                      type="text"
                      style={{ width: "100%", height: "80px"}}
                      id="affected_area_inputCalc"
                      value={notifyPayload.comments}
                      onChange={(e) => {
                          setNotifyPayload({ ...notifyPayload, comments: e.target.value });
                       }}
                   />
                </div>
                </div>
              </div> )}
              {!hideVendorName ? (
                  <div className="col-xl-11 col-lg-11 col-md-11 col-sm-11">
                    <div className="align_overlay2Field mt-2">
                      Vendor <span className="asteriskField"></span>
                    </div>
                    <Select
                      className="align_data_overlay2Field"
                      options={vendorList}
                      // value={selectedOption ? {label: selectedOption} : {label: "More Options"}}
                      //onChange={(e) => {setSelectedOption(e.label);navigateToTabs(e.value)}}
                          onChange={(e) => {
                            setNotifyPayload({ ...notifyPayload, vendorName: e.label }); getSurveyorList(e.value); setSurveyReqLoading(true); setSurveyor({
                              value: 'select',
                              label: 'select'
                            })
                          }}
                    ></Select>
                    {/* <select class = "align_data_overlay2Field">
                                    <option value = "" selected disabled hidden>Select Vendor</option>
                                    <option>Vendor 1</option>
                                    <option>Vendor 2</option>
                                </select> */}
                  </div>
                  ): ""}
                  <div className="col-xl-11 col-lg-11 col-md-11 col-sm-11">
                    <div className="align_overlay2Field mt-2">
                      Surveyor<span className="asteriskField"></span>
                    </div>
                    <Select
                      className="align_data_overlay2Field"
                      options={surveyorList}
                          value={surveyor.value !== 'select' && surveyor}
                          onChange={(e) => {
                            setNotifyPayload({ ...notifyPayload, surveyorName: e.name, surveyorMobile: e.value, surveyorID: e.email })
                            setSurveyor({
                              value: e.value,
                              label: e.label
                            });
                            setSurveyReqLoading(false)
                          }}
                    ></Select>
                    {/* <select class = "align_data_overlay2Field">
                                    <option value = "" selected disabled hidden>Select Surveyor</option>
                                    <option>Surveyor 1</option>
                                    <option>Surveyor 2</option>
                                </select> */}
                  </div>
                </div>
                <div style={{ paddingLeft: "20px" }}>
                {/* <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                    <div class="align_overlay2Field">
                    QC Lead <span class="asteriskField"></span>
                    </div>
                    <Select
                      class="align_data_overlay2Field"
                      options={qcLeadList}
                      onChange={(e)=>{setNotifyPayload({...notifyPayload,qcLead:e.label})}}
                    ></Select>
                  </div> */}
                  {/* <div class="col-xl-11 col-lg-11 col-md-11 col-sm-11">
                    <div class="align_overlay2Field mt-2">
                    QC Executive<span class="asteriskField"></span>
                    </div>
                    <Select
                      class="align_data_overlay2Field"
                      options={qcExecutiveList}
                      onChange={(e)=>{setNotifyPayload({...notifyPayload,qcExecutive:e.label})}}
                    ></Select>
                  </div> */}
                </div>
                    <button className="backField" disabled={surveyReqLoading && !surveyor.value === 'select'} onClick={() => clearData()}>Cancel</button>
                <button className="submit-1Field" disabled={surveyReqLoading} onClick={()=> {reAssignVendor ? reAssignSurvey() : submitRequestSurvey()}}>Submit</button>              
                </>
              )
            }
              </div>
        )}
    </>
  )
};

export default FieldSurveyRequest;